import { type DisciplinePhaseManager } from '@/app/types'

/**
 * Trieda pre fazu letu
 */
export class FlyingPhaseManager implements DisciplinePhaseManager {

  /**
   * Konstruktor
   */
  public constructor(private callbackEnd: () => unknown) {}

  public preparePhase(): void {

    // zatial nic

  }
  public startPhase(): void {

    console.warn('Flying phase started')

  }
  public finishPhase(): void {

    this.callbackEnd()
    // zatial nic

  }
  public update(): void {

    // zatial nic

  }
  public handleInputs(e: MouseEvent | undefined): void {

    // zatial nic

  }
  public setFinishPhaseTween(): void {

    // zatial nic

  }

  /**
   * reset fazy
   */
  public reset(): void {

    // zatial nic

  }

}